// @ts-ignore
import {View} from 'react-native';

interface KeyboardAwareScrollViewProps {
  children: React.ReactNode;
  style?: Record<string, string | number>;
}

export function KeyboardAwareScrollView({children, style}: KeyboardAwareScrollViewProps) {
  // @ts-ignore
  return <View style={style}>{children}</View>;
}
